import React, {useContext, useState} from "react";
import styles from './header.module.css';
import {Link} from "react-router-dom";
import axiosInstance from "../../../AxiosInstance";
import MyContext from "../../../MyContext";

const DEFAULT_BRAND = "#FF1235";

export default function Header({setSidebarOpen}) {
    const [menuOpen, setMenuOpen] = useState(false);
    const raw = localStorage.getItem('system_settings');
    const systemSettings = raw ? JSON.parse(raw) : {};
    const mainColor = systemSettings.main_color || DEFAULT_BRAND;
    const {user} = useContext(MyContext);

    const logout = () => {
        localStorage.clear();
        axiosInstance.defaults.headers.common['Authorization'] = null;
        window.location.href = '/login';
    };

    const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() || "Usuario";

    return (
        <header
            className={styles.headerContainer}
            style={{backgroundColor: mainColor}}
        >
            <div className={styles.headerRow}>
                <div className={styles.headerLeft}>
                    <img
                        src={systemSettings.image}
                        alt=""
                        className={styles.brandLogo}
                    />
                    <button
                        type="button"
                        className={styles.sidebarToggle}
                        onClick={() => setSidebarOpen?.((prev) => !prev)}
                        aria-label="Alternar menú lateral"
                    >
                        <span className={styles.toggleBar} aria-hidden />
                        <span className={styles.toggleBar} aria-hidden />
                        <span className={styles.toggleBar} aria-hidden />
                    </button>
                </div>

                <div className={styles.headerRight}>
                    <div className={styles.userBlock}>
                        <div className={styles.userName}>{fullName}</div>
                        {user?.email ? (
                            <div className={styles.userEmail}>{user.email}</div>
                        ) : null}
                    </div>
                    <button
                        type="button"
                        className={styles.avatarBtn}
                        onClick={() => setMenuOpen((prev) => !prev)}
                        aria-expanded={menuOpen}
                        aria-label="Menú de usuario"
                    >
                        <img
                            src={'/images/user_img.png'}
                            alt=""
                            className={styles.avatarImg}
                            width={38}
                            height={38}
                        />
                    </button>
                </div>
            </div>

            <nav
                className={`${styles.dropdown} ${!menuOpen ? styles.hide : ""}`}
                aria-hidden={!menuOpen}
            >
                <Link to={'/provider/profile'} className={styles.dropdownItem} onClick={() => setMenuOpen(false)}>
                    Mi perfil
                </Link>
                <div className={styles.dropdownDivider} aria-hidden />
                <button type="button" className={styles.dropdownItem} onClick={() => logout()}>
                    Cerrar sesión
                </button>
            </nav>
        </header>
    );
}
